// removed by extract-text-webpack-plugin
module.exports = {"container":"_3V3gAHvNV-oot2oQKcxfy","title":"_33648yWB-xzv5gHusmkypY"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Preparation/SSSellNoteAdvance/AdvanceForm/EspecialValues/styles.css
// module id = 3304
// module chunks = 0